import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form'
import Papa from "papaparse";
import axios from 'axios'
import "../App.css"
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom'
import FadeLoader from "react-spinners/FadeLoader";
import UnauthorizedAccess from './UnauthorizedAccess'

function UploadFSStudents({ IP, TOKEN }) {
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [duplicates, setDuplicates] = useState([])
    const [showDuplicates, setShowDuplicates] = useState(false)
    const [reports, setReports] = useState([])
    const [show, setShow] = useState(false);
    const [uploaded, setuploaded] = useState(false);
    const [uploading, setUploading] = useState(false)
    var [formData, setFormData] = useState([])
    const [fileDataAsObject, setFileDataAsObject] = useState({})
    const [fsBatches, setFsBatches] = useState([])

    const [unAuth, setUnauth] = useState(false)

    useEffect(() => {
        fetchFsBatchNames()
    }, [])

    const fetchFsBatchNames = async () => {
        await axios.get(`http://${IP}/fs-all-batch-names/${TOKEN}`)
            .then(res => {
                setFsBatches(res.data.FSBatches)
            })
            .catch(err => console.log(err))

    }

    const UploadStudentData = async () => {
        setShow(false)
        setUploading(true)
        delete formData.studentsEligibleFile
        formData = { ...formData, "fileDataAsObject": fileDataAsObject }
        let requestData = { formData, TOKEN }
        await axios.post(`http://${IP}/upload/fs-students-list`, requestData)
            .then((res) => {
                // notifySuccess(res.data.msg); 
                if (res.data.msg === "Unauthorized access") {
                    setUnauth(true)
                }
                else {
                    if (res.data.msg === "Data Uploaded successfully") {
                        setDuplicates(res.data.Duplicates);
                        setReports(res.data.Reports);
                        setUploading(false);
                        setuploaded(true)
                    }
                    else if (res.data.msg === "Selected file is incorrect or Columns not matched") {
                        notifyError(res.data.msg)
                    }
                }
                setUploading(false);
            })
            .catch(err => console.log(err))
    }

    const handleClose = () => {
        setShow(false);
        setuploaded(false)
    }
    var [filename, setFileName] = useState("")

    const confirmDialog = (data) => {
        setFileName(data.studentsEligibleFile[0].name)

        setFormData(data)
        setShow(true)
    }

    const showdup = () => {
        setShowDuplicates(!showDuplicates)
    }

    const openStudentsList = () => {
        navigate("/manage/fs-students")
        setuploaded(false)
    }

    // const notifySuccess = (msg) =>
    //     toast.success(msg, {
    //         position: "top-center",
    //         autoClose: 3000,
    //         hideProgressBar: true,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //     });

    // const notifyWarning = (msg) =>
    //     toast.warn(msg, {
    //         position: "top-center",
    //         autoClose: 3000,
    //         hideProgressBar: true,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //     });

    const notifyError = (msg) =>
        toast.error(msg, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    return (
        <div>
            {
                unAuth === true ?
                    <div>
                        <UnauthorizedAccess />
                    </div>
                    :
                    <div className='container mt-5 row col-lg-4 col-md-6 col-sm-8 col-xs-12 m-auto'>
                        <Modal show={show} onHide={handleClose} centered>
                            <Modal.Body>
                                <h6>You are uploading {formData.College} students list of {formData.FSBatch} batch from {filename} file</h6>
                                <p>If yes,click on confirm</p>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    Cancel
                                </Button>
                                <Button variant="primary" onClick={UploadStudentData}>
                                    Confirm
                                </Button>
                            </Modal.Footer>
                        </Modal>
                        <Modal show={uploaded} onHide={handleClose} centered>
                            <Modal.Body>
                                <h5>{reports.Inserted} records uploaded</h5>
                                <h5>{reports.Dup} duplicates found</h5>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    Ok
                                </Button>
                                <Button variant="success" onClick={openStudentsList}>
                                    View
                                </Button>
                            </Modal.Footer>
                        </Modal>
                        {
                            uploading === true ?
                                <div className='form-loading'>
                                    <FadeLoader
                                        className='mx-auto'
                                        color="#012951"
                                        loading={uploading}
                                    />
                                    <h5 className='text-center mt-2 p-3'>Uploading please wait...</h5>
                                </div>
                                :
                                <div className='upload-form'>
                                    <form className='mb-2 mt-2 p-0' onSubmit={handleSubmit(confirmDialog)}>
                                        <h5 className='text-start mb-1 mt-2 p-0'>Upload FS students list</h5>
                                        <div className='form-group'>
                                            <label htmlFor='clg'>College</label>
                                            <select className='form-select' id="clg" {...register("College", { required: true })}>
                                                <option value="" defaultChecked>Select College...</option>
                                                <option value="KMIT">KMIT</option>
                                                <option value="NGIT">NGIT</option>
                                                <option value="KMEC">KMEC</option>
                                            </select>
                                            {errors.College && <span className='text-danger'>College is required</span>}
                                        </div>
                                        <div className='form-group'>
                                            <label htmlFor='FSBatch'>FS Batch</label>
                                            <select className='form-select' id="FSBatch" {...register("FSBatchId", { required: true })}>
                                                <option defaultChecked value="all">Select FS Batch...</option>
                                                {
                                                    fsBatches.map(obj => <option value={obj.id} key={obj.id}>{obj.name}</option>)
                                                }
                                            </select>
                                            {errors.FSBatch && <span className='text-danger'>FS Batch is required</span>}
                                        </div>
                                        <div className='form-group'>
                                            <div className='d-flex justify-content-between'>
                                                <label htmlFor='s-csv'>Select students csv file</label>
                                                <p className='p-0 m-0'><a href={`http://${IP}/Sample_FS_Students.csv`} style={{ textDecoration: 'none' }}>sample csv file</a></p>
                                            </div>
                                            <input type="file" id='s-csv' className='form-control' {...register("studentsEligibleFile", { required: true })}
                                                accept=".csv"
                                                onChange={(e) => {
                                                    const files = e.target.files;
                                                    if (files) {
                                                        Papa.parse(files[0], {
                                                            header: true,
                                                            complete: function (results) {
                                                                setFileDataAsObject(results.data)
                                                            }
                                                        }
                                                        )
                                                    }
                                                }}
                                            />
                                            {errors.studentsEligibleFile && <span className='text-danger p-0'>Select .csv file</span>}
                                        </div>

                                        <div className='form-group text-center'>
                                            <button className='btn btn-success m-auto w-100'>Upload</button>
                                        </div>
                                    </form>
                                </div>
                        }

                        {
                            (reports.length != 0) &&
                            <table className='table table-responsive table-bordered m-auto w-100 mb-2 mt-2'>
                                <tbody>
                                    <tr>
                                        <th>Total Records</th>
                                        <th>Inserted</th>
                                        <th>Duplicates</th>
                                        <th>Empty Fields</th>
                                    </tr>
                                    <tr>
                                        <td>{reports.Total}</td>
                                        <td>{reports.Inserted}</td>
                                        <td>{reports.Dup}</td>
                                        <td>{reports.EmptyFields}</td>
                                    </tr>
                                    <tr className='text-center'>
                                        <td colSpan="4"><button className='btn btn-link p-0' onClick={showdup}>{showDuplicates == true ? <>Hide Duplicates</> : <>Show Duplicates</>}</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        }
                    </div>
            }
            <div className='container-fluid'>
                {
                    showDuplicates == true && duplicates.length != 0 &&
                    <table className='m-auto table table-responsive'>
                        <tbody>
                            <tr>
                                <th>Roll No</th>
                                <th>Student Name</th>
                            </tr>
                            {
                                duplicates.map((obj) => <tr key={obj.RollNo}>
                                    <td>{obj.RollNo}</td>
                                    <td>{obj.StudentName}</td>
                                </tr>
                                )
                            }
                        </tbody>
                    </table>
                }
            </div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div >
    )
}

export default UploadFSStudents